module.exports = __webpack_public_path__ + "static/scale-model-of-east-arbor-charter-in-ann-arbor-michigan-7dd03059f185f5182b0c3ffbae6600dc.png";